<template>
  <div>
    <sidebar :mobile="mobile" :toggleSidebar="toggleSidebar" />
    <navbar :mobile="mobile" :toggleSidebar="toggleSidebar" />
    <div
      class="dashboard__content dashboard"
      :class="{ bg: getRoute === 'loans', rmPadding: getRoute === 'dashboard' }"
    >
      <unauthorised v-if="unauthorised" />
      <router-view v-else />
    </div>
  </div>
</template>

<script>
import sidebar from "./sidebar";
import navbar from "./navbar";
import Unauthorised from "../resuables/unauthorised.vue";
import { mapState } from "vuex";
export default {
  name: "dashboardFrame",
  components: {
    sidebar,
    navbar,
    Unauthorised
  },
  data() {
    return { mobile: false, routes: ["dashboard"] };
  },
  methods: {
    toggleSidebar() {
      this.mobile = !this.mobile;
    }
  },
  computed: {
    ...mapState("auth", ["unauthorised"]),
    getRoute() {
      return this.$route.name;
    }
  },
  watch: {
    $route: {
      handler(to, from) {
        if (this.unauthorised) {
          this.$store.commit("auth/unauthorised", false);
        }
        if (this.mobile == true) {
          this.mobile = false;
        }
      },
      immediate: true
    }
  }
};
</script>

<style scoped>
.rmPadding {
  padding-top: 0;
  padding-bottom: 0;
}

.dashboard {
  height: 100%;
  min-height: calc(100vh - 100px);
  position: relative;
}
</style>



// WEBPACK FOOTER //
// src/components/dashboard/dashboardFrame.vue